import React from "react";
import TextEdit from "../../components/TextEdit/TextEdit";

const Restaurants = props => {
	const style = {
		display: "grid",
		gridTemplateColumns: "repeat(1,1fr)",
		gridGap: "10px",
		gridAutoRows: "minmax(100px,auto)"
	};

	return (
		<div>
			<h2 style={{ width: "100%", textAlign: "left" }}>Gastronomia</h2>

			<div style={style}>
				{props.restaurants.map(l => (
					<TextEdit
						id={l.id}
						name={l.name}
						shortdesc={l.shortdesc}
						descripcion={l.descripcion}
						handleSaveButton={props.handleSaveButton}
						token={props.token}
					/>
				))}
			</div>
		</div>
	);
};

export default Restaurants;
